/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantNeighborhoodsEnrollments} from '../api'

 export const useQueryGetMerchantNeighborhoodsEnrollments = createReactQueryHook('getMerchantNeighborhoodsEnrollments', getMerchantNeighborhoodsEnrollments)
